import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.action.DOC}
  query MosaicActions($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          actions {
            ...FragmentMosaicAction
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.MosaicActionsQuery,
    ents.core.mosaic.Action[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'mosaicDev',
        graphql.transformers.OUT.select(
          'actions',
          graphql.transformers.OUT.list(fragments.action.TRANSFORMER, {
            onNullish: 'remove',
          }),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.MosaicActionsQuery,
  ents.core.mosaic.Action[],
  graphql.schema.MosaicActionsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
